import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';



class _ControlBase extends compose(_WidgetBaseSP) {
    protected selectInfo: HTMLElement;
    protected selectInfoContainer: HTMLElement;
    protected _value: any;
    protected _cyName: string;


    focus() {
        return; // ohne Input kein Focus - muss auf Childklassen übersteuert werden!
    }

    protected isFocused: boolean = false;
    protected _valueCommitted: any;

    protected _onFocus(evt: Event) {
        if (!this.isFocused) {
        
            this._valueCommitted = this._value;
            //console.debug(this.id + " _onFocus", this._valueCommitted);
        }
        this.isFocused = true;

        this.emit("focus");
    }

    private _blurEmitHandle: any = null;
    protected _onBlur(evt: Event) {
        this.isFocused = false;

        //console.debug(this.id + " _onBlur");

        if (this._blurEmitHandle != null) {
            clearTimeout(this._blurEmitHandle);
            this._blurEmitHandle = null;
        }
        this._blurEmitHandle = setTimeout(lang.hitch(this, this.emit, "blur"), 50);
    }

    focusedValueChangeEmitterDelay: number = 2000; // Delay während focus bevor ein keyup wirklich zum Emit führt
    valueChangeEmitterDelay: number = 88; // Delay bevor ein keyup wirklich zum Emit führt
    protected valueChangeTimeoutHandle: number = null;

    protected _valueEmitted: any;
    protected __delayValueChangeEmit(delay?: number): void {
        if (this.valueChangeTimeoutHandle != null) {
            clearTimeout(this.valueChangeTimeoutHandle);
            this.valueChangeTimeoutHandle = null;
        }

        //console.debug(this.id + " __delayValueChangeEmit - focused?", this.isFocused);
        if (this.isFocused) {
            this.valueChangeTimeoutHandle = setTimeout(lang.hitch(this, this.emitChangeEvent), delay ? delay : this.focusedValueChangeEmitterDelay);
        } else {
            this.valueChangeTimeoutHandle = setTimeout(lang.hitch(this, this.emitChangeEvent), delay ? delay : this.valueChangeEmitterDelay);
        }

    }

    protected emitChangeEvent(): void {
        try {
            this._valueEmitted = lang.clone(this._value);
        } catch (ex) {
            this._valueEmitted = this._value;
        }


        this.emit("valueChange", this._value);
        this.emit("change", this._value);
    }
    protected drawSelectInfoLabel(availableCount: number = 0, selectedCount: number = 0, showSelectedIfZero: boolean = false) {
        if (!this.selectInfo) return;

        this.UiModder.domConstruct.empty(this.selectInfo);

        if (this.selectInfo.parentElement?.id == "selectInfoContainer") this.selectInfoContainer = this.selectInfo.parentElement;

        if (availableCount <= -1) {
            this.hideNode(this.selectInfo);
            return;
        }

        let text = availableCount.toString();

        let icon = null;
        if (selectedCount > 0 || showSelectedIfZero == true && selectedCount == 0) {
            if (selectedCount) {
                icon = this.createFontawesomeIcon("fas fa-check-circle selectInfoIcon", "&nbsp");

                text = icon.outerHTML + selectedCount.toString() + "/" + text;
            }
            else {
                icon = this.createFontawesomeIcon("far fa-circle selectInfoIcon", "&nbsp");

                text = icon.outerHTML + selectedCount.toString() + "/" + text;
            }
        }

        if (this.selectInfoContainer) {
            this.UiModder.domClass.toggle(this.selectInfoContainer, "noneSelected", selectedCount <= 0);
            this.UiModder.domClass.toggle(this.selectInfoContainer, "noneAvailable", availableCount <= 0);
            this.UiModder.domClass.toggle(this.selectInfoContainer, "complete", selectedCount >= availableCount && availableCount > 0);
        }

        this.UiModder.domAttr.set(this.selectInfo, "innerHTML", text);
        this.hideNode(this.selectInfo, false);
    }

    dataFormat: "json" | "pit" | more.PitHelperStructureFormatType = more.PitHelperStructureFormatType.json; // "pit" oder "json" // 
    // dojo
    // test merge hadyn to moreCore

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (!this._cyName) {
            const dataKeyEl = (this.domNode as HTMLElement)?.closest("[data-key]");
            const dataKey = dataKeyEl?.getAttribute("data-key") ?? "";
            if (dataKey) {
                // Sektions-Präfix bevorzugt aus explizitem, stabilem data-cy-section (kundenneutral,
                // vom Entwickler bewusst gesetzt), sonst Fallback auf den beiläufigen/kundenspezifischen
                // data-dojo-attach-point. So bleiben data-cy stabil, auch wenn Attach-Points umbenannt werden.
                const sectionEl = dataKeyEl.parentElement?.closest("[data-cy-section], [data-dojo-attach-point]");
                const section = sectionEl?.getAttribute("data-cy-section") ?? sectionEl?.getAttribute("data-dojo-attach-point") ?? "";
                this.setCyName([section, dataKey].filter(Boolean).join(":"));
            }
        }
    }

    setCyName(name: string) {
        this._cyName = name;
        this.setAllDataCyAttributes();
    }
    getCyName(): string {
        return this._cyName;
    }

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.domNode, "");
    }

    public setDataCyAttribute(element: HTMLElement, label: string) {
        if (!element) return;
        if (this._cyName) {
            element.setAttribute("data-cy", [this._cyName, label].filter(Boolean).join(":"));
        } else {
            element.setAttribute("data-cy", [this._findDataLabelFromSelfOrParent(element), label].filter(Boolean).join(":"));
        }
    }

    private _findDataLabelFromSelfOrParent(node: Element | null): string {
        if (!node) {
            return "";
        }

        const dataKey = node.closest("[data-key]")?.getAttribute("data-key") ?? "";
        const dataCy = node.parentElement?.closest("[data-cy]")?.getAttribute("data-cy") ?? "";

        const result = [dataKey, dataCy].filter(Boolean).join(":");

        if (result) {
            return result;
        }

        return node.closest("[data-dojo-attach-point]")?.getAttribute("data-dojo-attach-point") ?? "";
    }
}

export default mdsWidget(_ControlBase);